<!--used in version 3.3 backward-->
<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title items">ITEMS</td>
          <td class="listview__title placement">PLACEMENT</td>
          <td class="listview__title dailyvisitor" v-if="category == 'malls' || category == 'spbu'">DAILY TRAFFIC</td>
          <td class="listview__title dailyvisitor" v-else>DAILY VISITOR</td>
          <td class="listview__title price">PRICE / DAY</td>
          <td class="save"></td>
          <td class="action" v-if="isAction"></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" @click.stop="listClick(item)" class="content">
          <td class="items">
            <div class="item">
              <img v-if="item.thumbnail_square" :src="item.thumbnail_square" alt="">
              <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
              <div class="stack">
                <span class="title">{{item.location_name}}</span>
                <span class="location" v-if="item.category === 'AR' && item.airport">
                  {{item.airport.airport_name}} . {{item.city_name}}
                </span>
                <span class="location" v-else>
                  {{item.property_type_display}} . {{item.city_name}}
                </span>
                <span class="price-mobile">{{item.price | formatMoney}}</span>
              </div>
            </div>
          </td>
          <td class="placement none"><span>{{item.placement}}</span></td>
          <td v-if="item.is_audience_displayed" class="visitor none"><span>{{item.audience_daily}} people</span></td>
          <td v-else class="visitor none"><span>-</span></td>
          <td class="price none"><span>{{item.price | formatMoney}}</span></td>
          <td class="icon-list icon-view-desktop">
            <adx-tooltip :text="tooltipText(item.id)">
              <span slot="content">
                <div class="icon-wrapper" @click.stop="addRemoveDevice(item)">
                  <adx-loading-secondary v-if="isLoading.includes(item.id)" />
                  <i v-if="!isLoading.includes(item.id)" :class="iconSelection(item.id)"></i>
                </div>
              </span>
            </adx-tooltip>
          </td>
          <td class="icon-list icon-view-mobile">
            <div class="icon-wrapper" @click.stop="addRemoveDevice(item)">
              <adx-loading-secondary v-if="isLoading.includes(item.id)" />
              <i v-if="!isLoading.includes(item.id)" :class="iconSelection(item.id)"></i>
            </div>
          </td>
          <td class="menu-action" @click.stop v-if="isAction"><menu-expansion :itemID="item.id" @selected="selected" :lists="menuList" /></td>
        </tr>
      </tbody>
    </table>
    <div class="listview__showmore">
      <slot name="infiniteLoading"/>
    </div>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !loading" />
    </div>
    <div class="listview__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import Alert from '@/components/Alert'
import LoadingSecondary from '@/components/Loading/Secondary'
import EmptySelection from '@/components/NotFound/Selection'
import Tooltip from '@/components/Tooltip'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-list-view',
  components: {
    'menu-expansion': MenuExpansion,
    'adx-alert': Alert,
    'adx-loading-secondary': LoadingSecondary,
    'adx-empty-selection': EmptySelection,
    "adx-tooltip": Tooltip
  },
  props: {
    items: {
      required: false
    },
    headers: {
      required: false
    },
    category: {
      required: false
    },
    menuList: {
      required: false
    },
    page: {
      required: false
    },
    isAction: {
      required: false
    },
    loading: {
      required: false
    }
  },
  data() {
    return {
      isHover: null,
      isEmpty: false,
      lists: [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "S",
          "items": [
            {
              "name": "Create new saved"
            },
            {
              "name": "Saved Gaul"
            },
            {
              "name": "Saved Konser"
            },
            {
              "name": "Saved Nobar"
            },
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "AP",
          "items": [
            {
              "name": "Create new campaign"
            },
            {
              "name": "Gaul"
            },
            {
              "name": "Konser"
            },
            {
              "name": "Nobar"
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "KO"
        },
        {
          "id": 3,
          "name": "More from this brand",
          "value": "Mo"
        }
      ],
      saved: [],
      isLoading: []
    }
  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  methods: {
    addRemoveDevice(item) {
      (async () => {
        this.isLoading.push(item.id)
        let category = this.category
        const isLogin = this.token

        if(isLogin) {
          const { response, msg } = await this.$store.dispatch('addRemoveSaved', {item: item, category: category})

          this.$notify({
            group: 'saved',
            title: msg.title,
            text: msg.text,
            type: msg.type
          });

          this.isLoading = []
        }else {
          this.$router.push({name: 'signin', query: { next: this.$route.name }})
        }

      })();

    },
    iconSelection(id) {
      const listSaved = this.defaultSaved[this.category]
      const isLogin = this.token

      if(isLogin && listSaved) {
        if (listSaved.includes(id)) {
          return 'adx-ic_check'
        } else {
          return 'adx-ic_plus'
        }
      }else {
        return 'adx-ic_plus'
      }


    },
    tooltipText(id) {
      const listSaved = this.defaultSaved[this.category]
      if(listSaved){
        if (listSaved.includes(id)) {
          return `remove saved`
        } else {
          return `add to saved`
        }
      } else {
        return `add to saved`
      }
    },
    setID(id){

    },
    selected(menuObject) {
      if (menuObject.value == 'saved') {
        let category = this.category
        const devices = ['lifestyle', 'malls', 'spbu', 'airport']
        if (devices.includes(category)) {
          category = 'device'
        }
        if (menuObject.items.value !== 0) {
          let data = {
              'target_id': menuObject.items.value,
              [category]: menuObject.item_id
          };
          (async () => {
            const response = await api.patch(apiV2.savedCopy, data, { needToken: true })
            if (response.status == 200) {
              let item = this.items.filter(value => {
                return value.id == menuObject.item_id
              })[0]
              let saved = this.menuList[0].items.filter(obj => {
                return obj.value == menuObject.items.value
              })[0]
              this.$notify({
                group: 'saved',
                title: 'Added to saved',
                text: item.location_name + ' has been added to ' + saved.name + ' folder',
                type: 'success'
              });
            }else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: 'sorry something went wrong!',
                type: 'warn'
              });
            }
          })();
        } else {
          const params = {
            [category+'s']: [menuObject.item_id]
          }
          this.$emit('createNew', params)
        }
      } else if (menuObject.value == 'campaign'){
        let category = this.category
        const devices = ['lifestyle', 'malls', 'spbu', 'airport']
        if (devices.includes(category)) {
          category = 'idooh'
        }
        if (menuObject.items.value !== 0) {
          let data = {
              'channel_id': menuObject.item_id,
              'channel_name': category
          };
          (async () => {
            const response = await api.patch(apiV2.campaignAddListing(menuObject.items.value), data, { needToken: true })
            if (response.status == 200) {
              let item = this.items.filter(value => {
                return value.id == menuObject.item_id
              })[0]
              let campaign = this.menuList[1].items.filter(obj => {
                return obj.value == menuObject.items.value
              })[0]
              this.$notify({
                group: 'saved',
                title: 'Added to campaign',
                text: item.location_name + ' has been added to ' + campaign.name,
                type: 'success'
              });
            }else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: 'sorry something went wrong!',
                type: 'warn'
              });
            }
          })();
        } else {
          let item = this.items.filter(value => {
            return value.id == menuObject.item_id
          })[0]
          const params = {
            category: category,
            device_id: menuObject.item_id,
            location_name: item.location_name
          }
          this.$emit('createNewCampaign', params)
        }
      } else if (menuObject.value == 'detail') {
        let item = this.items.filter(value => {
          return value.id == menuObject.item_id
        })[0]
        this.listClick(item)
      }
    },
    listClick(item) {
      this.$emit('item-clicked', item)
    },
  },
  computed: {
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token'
    }),
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>